import { render, staticRenderFns } from "./DialogBindFailed.pug?vue&type=template&id=c37cf858&scoped=true&lang=pug&"
import script from "./DialogBindFailed.vue?vue&type=script&lang=js&"
export * from "./DialogBindFailed.vue?vue&type=script&lang=js&"
import style0 from "./DialogBindFailed.scss?vue&type=style&index=0&id=c37cf858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37cf858",
  null
  
)

export default component.exports